'use client';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function Page() {
  const { data: session, status } = useSession();
  const t = useTranslations('home');
  const tCommon = useTranslations('common');

  if (status === 'loading') {
    return (
      <main className="p-6">
        <div className="text-center">{tCommon('loading')}</div>
      </main>
    );
  }

  return (
    <main className="p-6">
      <h1 className="mb-4 text-2xl font-semibold">{t('title')}</h1>
      <p className="mb-6 text-sm opacity-80">{t('tagline')}</p>

      {session?.user ? (
        <div className="space-y-4">
          <Card className="p-4">
            <h2 className="mb-2 text-lg font-medium">{t('welcomeBack')}</h2>
            <p className="mb-4 text-sm text-gray-600">
              {t('signedInAs', { email: session.user.email })}
            </p>
            <div className="flex gap-3">
              <Button asChild>
                <Link href="/en/dashboards">{t('goToDashboard')}</Link>
              </Button>
              <Button variant="outline" asChild>
                <Link href="/en/integrations">{t('manageIntegrations')}</Link>
              </Button>
            </div>
          </Card>
        </div>
      ) : (
        <div className="space-y-4">
          <Card className="p-4">
            <h2 className="mb-2 text-lg font-medium">{t('getStarted')}</h2>
            <p className="mb-4 text-sm text-gray-600">
              {t('getStartedDescription')}
            </p>
            <div className="flex gap-3">
              <Button asChild>
                <Link href="/en/register">{t('createAccount')}</Link>
              </Button>
              <Button variant="outline" asChild>
                <Link href="/en/login">{tCommon('signIn')}</Link>
              </Button>
            </div>
          </Card>
        </div>
      )}
    </main>
  );
}
